import React from "react";
import { Chip } from "@material-ui/core";
import { useCompany } from "../../Context/CompanyContext";

const DAY_MS = 24 * 60 * 60 * 1000;

// Whole calendar days from today to an expiry date (0 = today, negative =
// already expired). Expiry dates are stored as midnight UTC of the date, so the
// UTC parts are the date itself - same rule as the server (daysUntilExpiry).
export const daysUntilExpiry = (expiryDate, now = new Date()) => {
  if (!expiryDate) return null;
  const e = new Date(expiryDate);
  if (Number.isNaN(e.getTime())) return null;
  const expiryDay = Date.UTC(e.getUTCFullYear(), e.getUTCMonth(), e.getUTCDate());
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((expiryDay - today) / DAY_MS);
};

export const formatExpiry = (expiryDate) =>
  expiryDate
    ? new Date(expiryDate).toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric", timeZone: "UTC" })
    : "-";

const LEVELS = {
  expired: { background: "#fee2e2", color: "#b91c1c" },
  near: { background: "#fef3c7", color: "#b45309" },
  ok: { background: "#dcfce7", color: "#15803d" },
};

// "28 Oct 2026 · 26d left", coloured green / amber / red by how close it is.
const ExpiryChip = ({ date, compact = false }) => {
  const { company } = useCompany();
  const nearDays = Number(company?.nearExpiryDays) || 30;
  const days = daysUntilExpiry(date);
  if (days === null) return <span style={{ color: "#94a3b8" }}>-</span>;
  const level = days < 0 ? "expired" : days <= nearDays ? "near" : "ok";
  const hint = days < 0 ? `${Math.abs(days)}d ago` : days === 0 ? "today" : `${days}d left`;
  return (
    <Chip
      size="small"
      label={compact ? formatExpiry(date) : `${formatExpiry(date)} · ${hint}`}
      title={days < 0 ? `Expired ${Math.abs(days)} day(s) ago` : days === 0 ? "Expires today" : `Expires in ${days} day(s)`}
      style={{ fontWeight: 700, fontSize: "0.74rem", ...LEVELS[level] }}
    />
  );
};

export default ExpiryChip;
